import { FormEvent, useState, useContext } from "react";
import { Redirect } from "react-router";
import { AppContext } from "../../context/App";
import Loader from '../../components/Loader';
import { appPaths, updateConfig } from '../../helpers';
import { useTracking } from "../../hooks/useTracking";

import * as S from './styled';

function Welcome() {
	const [event] = useTracking();
	const [trackingEnabled, setTrackingEnabled] = useState<boolean>(true);
	const [loading, setLoading] = useState<boolean>(false);
	const {isWelcomeDone, dispatchConfig} = useContext(AppContext);

	function handleSubmit(e: FormEvent) {
		e.preventDefault();

		setLoading(true);

		const config = {
			"is_welcome_done": "contribution",
			"ga_enabled_status": trackingEnabled
		};

		updateConfig(config)
			.then(
				(status) => {
					if (status === 200) {
						trackingEnabled && event({
							category: 'LP RevGen',
							action: 'Welcome Landing Page',
							label: 'Contributions'
						});

						dispatchConfig({ payload: { isWelcomeDone: true } });
					}
				}
			);
	}

	return (
		<>
			<Loader enabled={loading} />

			{isWelcomeDone && <Redirect to={`${appPaths.builder}/?tutorial=1`} />}

			<form onSubmit={handleSubmit}>
				<S.Container>
					<S.Left>
						<S.Title>Welcome to<br />Revenue Generator 2.0</S.Title>

						<S.Paragraph>Requesting contributions, selling single articles, time passes, and subscriptions have never been easier.</S.Paragraph>

						<S.Paragraph>Your readers and viewers already love your content - the Revenue Generator makes it easy for them to support you. Sell individual pieces of content, timed access to your site, recurring subscriptions, or request contributions - at any price point. Instead of requiring upfront registration and payment, we defer this process until customer purchases combined reach a $5 threshold. Earn money from all of your users, not just subscribers.</S.Paragraph>

						<S.CheckboxLabel>
							<input
								type="checkbox"
								checked={trackingEnabled}
								onChange={(e) => setTrackingEnabled(e.target.checked)}
							/>
							Enable usage tracking and help improve Revenue Generator
						</S.CheckboxLabel>
					</S.Left>
					<S.Right>
						<S.WhereTitle>Where would you like to start?</S.WhereTitle>

						<S.Button variant="contribution">
							<span className="icon"></span>
							Create Contribution
						</S.Button>
					</S.Right>
				</S.Container>
			</form>
		</>
	)
}

export default Welcome;
